<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/180vFMQ/tc-custom/9780743420488.jpg?1730518031401" alt="This image is the cover for the book Heart of the Warrior, Star Trek: Deep Space Nine"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Heart of the Warrior, Star Trek: Deep Space Nine
      </h1>
      <p class="bookDescription body article font2">
        <p>While a crucial peace conference fills <i>Deep Space Nine</i>TM with rumors of intrigue and conspiracy, Major Kira and Lt. Commander Worf embark on a dangerous undercover mission deep into the heart of the Gamma Quadrant. Their mission: to find the secret of the addictive substance that the Changelings use to control their Jem'Hadar warriors. But how long can Worf and Kira remain undetected in the midst of the Dominion? Odo may be their only hope; but to save them, he'll have to stand against his own people.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Gregory Betancourt
      </h2>
      
      <p class="authorDescription body article">John Gregory Betancourt is the bestselling author of more thirty books, including several&#160;<I>Star Trek </I>novels and the Dawn of Amber trilogy.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gallery
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?770e3672